import React from "react";
import IconLink from "./IconLink";
import { Box, Grid } from "@mui/material";
import Terminal from "../about/Terminal";
import { info } from "../../info/Info";

export function Ls({ title, about }) {
  return (
    <div>
      <p>
        <span style={{ color: info.baseColor }}>
          {"bibhutiswain"}
          {info.lastName.toLowerCase()} $
        </span>{" "}
        cat {title}
      </p>
      <p>
        <span style={{ color: info.baseColor }}>
          {"bibhutiswain"}
          {info.lastName.toLowerCase()} $
        </span>{" "}
        {about}
      </p>
    </div>
  );
}

function PortfolioBlock(props) {
  const { image, about, title } = props;
  return (
    <Grid container xs={12} md={12} style={{ height: "90vh" }}>
      <Grid item xs={12} md={12} style={{ height: "60%" }}>
        <Box
          component={"img"}
          src={image}
          alt={"mockup"}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </Grid>
      <Grid item xs={12} md={12} style={{ height: "30%" }}>
        <Box
          className={"portfolio"}
          display={"flex"}
          flexDirection={"column"}
          gap={"0.5rem"}
          alignItems={"center"}
          fontSize={"1.5rem"}
          py={"2rem"}
        >
          <Terminal text={Ls({ title, about })} />
        </Box>
      </Grid>
    </Grid>
  );
}

export default PortfolioBlock;
